<template>
  <section
    v-if="variants.v1 === variant"
    class="n-section-secondary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <h3>{{ vars.titleText }}</h3>

    <!-- tabs -->
    <div
      class="scrollbar-hide tw-my-4 tw-flex tw-snap-x tw-snap-mandatory tw-snap-start tw-items-center tw-overflow-x-auto md:tw-mb-14 md:tw-w-full md:tw-justify-center"
      style="white-space: nowrap; max-width: 100%"
    >
      <button
        v-for="branch in branches"
        :key="branch.id"
        class="select-button tw-mx-2 tw-inline-block !tw-w-[unset]"
        :class="selectedBranch === branch.id ? 'select-button active' : 'select-button'"
        @click="selectedBranch = branch.id"
      >
        {{ branch.name }}
      </button>
    </div>

    <div class="tw-w-screen">
      <neuron-google-map-v2
        v-if="mapToDisplay && mapToDisplay.length"
        v-model:markers="mapToDisplay"
        :center="mapToDisplay[0]"
        :markerImg="mapToDisplay[0].marker"
      />
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="n-section-secondary !tw-py-0"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-w-screen">
      <neuron-google-map-v2
        v-if="mapToDisplay"
        v-model:markers="mapToDisplay"
        :center="mapToDisplay[0]"
        :markerImg="mapToDisplay[0].marker"
      />
    </div>
  </section>

  <!-- v3: tek haritada çoklu konum -->
 <section
  v-if="variants.v3 === variant"
  :style="`background-color: var(--c-${vars.backgroundColor})`"
>
  <div class="tw-w-screen">
    <neuron-google-map-v2
      v-if="v3Markers && v3Markers.length"
      v-model:markers="v3Markers"
      :center="v3Center"
      :markerImg="v3Markers[0]?.marker"
      :marker-color="colors?.purple"  
      class="!tw-h-[80vh] tw-w-full"
    />
  </div>
</section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import NeuronGoogleMapV2 from '~/components/common/NeuronGoogleMapV2.vue';

export default defineNuxtComponent({
  name: 'BranchesLocation',
  mixins: [ComponentMixin],
  components: { NeuronGoogleMapV2 },

  data() {
    return {
      selectedBranch: 0,
      variants: { v1: 'v1', v2: 'v2', v3: 'v3' },
    };
  },

  computed: {
    branches() {
      return this.groupedVariables.branches || [];
    },

    maps() {
      // ORİJİNALİN KALSIN
      return this.groupedVariables.locations || [];
    },

    // 🔧 YENİ: v3 için "long" -> "lng" normalize
    normalizedMaps(): any[] {
      return (this.maps || []).map((m: any) => ({
        ...m,
        // bazı feed'lerde long geliyor; lng yoksa long'u kullan
        lng: m?.lng ?? m?.long,
        lat: m?.lat,
      }));
    },

    mapToDisplay() {
      if (this.variants.v1 === this.variant) {
        return this.maps.filter((m: any) => m.branch_id === this.selectedBranch);
      } else if (this.variants.v2 === this.variant) {
        return [
          {
            branch_id: this.vars.branchId,
            lat: this.vars.locationLatNumber,
            lng: this.vars.locationLngNumber,
            marker: this.vars.locationMarkerImage,
          },
        ];
      }
      return [];
    },

    // 🔧 GÜNCEL: v3'te seçim yoksa TÜM markerları göster
    v3Markers(): any[] {
      if (this.variants.v3 !== this.variant) return [];
      // tabs yoksa selectedBranch genelde 0 olur; bu durumda hepsini göster
      if (!this.selectedBranch || this.selectedBranch === 'all') return this.normalizedMaps;
      return this.normalizedMaps.filter((m: any) => m.branch_id === this.selectedBranch);
    },

    v3Center(): { lat: number; lng: number } {
      const ms = this.v3Markers;
      if (!ms || ms.length === 0) {
        return {
          lat: Number(this.vars?.locationLatNumber) || 0,
          lng: Number(this.vars?.locationLngNumber) || 0,
        };
      }
      const lat = ms.reduce((s: number, m: any) => s + Number(m.lat), 0) / ms.length;
      const lng = ms.reduce((s: number, m: any) => s + Number(m.lng), 0) / ms.length;
      return { lat, lng };
    },
  },
});
</script>

